import { useQueryClient } from '@tanstack/react-query'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory, useParams } from 'react-router-dom'

import { Spinner } from '../../App/Components'
import { useAppDispatch } from '../../App/Hooks/reduxHooks'
import {
  AbsenceFormBase,
  IAbsenceFormBaseData,
  IAbsenceRequestProps,
} from '../layout/AbsenceFormBase/AbsenceFormBase'
import { handelFormError } from '../layout/AbsenceFormBase/handelFormError'
import { handelFormSuccess } from '../layout/AbsenceFormBase/handelFormSuccess'
import { IAbsenceFormBasePayload } from '../layout/AbsenceFormBase/IAbsenceFormBasePayload'

import {
  useGetAbsenceRequestQuery,
  usePutAbsenceRequestMutation,
} from './util/useAbsenceRequestQuery'

export const EditAbsenceRequestNewPage = () => {
  const { absenceRequestUuid } = useParams<{ absenceRequestUuid: string }>()
  const queryClient = useQueryClient()

  const { data, status } = useGetAbsenceRequestQuery(absenceRequestUuid)

  const putAbsenceRequest = usePutAbsenceRequestMutation(queryClient)

  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const history = useHistory()

  const handleDataFromChild = (payload: IAbsenceFormBasePayload) => {
    putAbsenceRequest.mutate({ absenceRequest: payload, absenceRequestUuid })
  }

  const editAbsenceRequest: IAbsenceRequestProps = {
    type: 'absence-request',
    overviewPath: '/hr/absence-requests',
    pageTitle: t('Edit absence request'),
    isSelectPerson: false,
    requestStatus: putAbsenceRequest.status,
    newPayload: handleDataFromChild,
  }

  useMemo(
    () =>
      handelFormError(
        'Could not edit absence request.',
        putAbsenceRequest.error,
        t,
        dispatch,
      ),
    [putAbsenceRequest.error, t, dispatch],
  )

  useMemo(() => {
    if (putAbsenceRequest.isSuccess) {
      handelFormSuccess(t('Absence request Edited.'), dispatch)
      history.push(editAbsenceRequest.overviewPath)
    }
  }, [putAbsenceRequest.isSuccess, history, t, dispatch])

  if (status === 'pending') return <Spinner />

  if (status === 'error') return <p>something went wrong</p>

  const transformedGeneralAbsence: IAbsenceFormBaseData = {
    startsAt: data.startsAt,
    endsAt: data.endsAt,
    absenceTypeUuid: data.absenceType.uuid,
    reason: data.reason,
  }

  return (
    <AbsenceFormBase {...editAbsenceRequest} data={transformedGeneralAbsence} />
  )
}
